import { 
  SAVE_PATIENT_DATA
} from './patientConstants';


export const savePatientData = (data: any) => {
	return (dispatch:any) => {
    dispatch({type: SAVE_PATIENT_DATA, data})
	};
};